import React from 'react';
import Button from '../../../../../../incase-domain/components/button/Button';
import {IElementQuestionAnswer, IElementQuestionnaire} from '../../../../../../incase-domain/elements/base/questionElementBase';
import useImgFileReader from '../../../../../fileLoader/util/useImgFileReader';
import HighlightedInputMedia from '../../../../../fileLoader/input.media';

interface IChangePhotoAnswerProps {
    index: number;
    imgSrc: string | undefined;
    highlightedElement: IElementQuestionnaire;
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaire | string, value: unknown) => void};
}

function ChangePhotoAnswer({index, imgSrc, highlightedElementChangeHandler, highlightedElement}: IChangePhotoAnswerProps): JSX.Element {
    function answerImageChangeHandler(partIndex: number, result: string, widthHeightRatio: number): void {
        const newAnswers: (IElementQuestionAnswer & {
            imgSrc?: string;
            imageRatio?: number;
        })[] = [...highlightedElement.answers];
        newAnswers[partIndex] = {...newAnswers[partIndex], imgSrc: result, imageRatio: widthHeightRatio};
        highlightedElementChangeHandler.single('answers', newAnswers);
    }

    const onFileLoad = useImgFileReader((images) => {
        const image = images[0];
        answerImageChangeHandler(index, image.imageSrc, image.widthHeightRatio);
    });

    return (
        <>
            <HighlightedInputMedia
                type="image"
                onLoad={onFileLoad}
                child={
                    <Button
                        variant="ghost"
                        size="sm"
                        square
                        leading={imgSrc ? 'solar:gallery-minimalistic-bold' : 'solar:gallery-minimalistic-linear'}
                        color={imgSrc ? 'secondary' : 'primary'}
                        key={`${index}-comment`}
                    />
                }
            />
        </>
    );
}

export default ChangePhotoAnswer;
